export default __webpack_public_path__ + "static/media/error-icon.150c3e67.svg";